import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import CustomerContext from 'Components/CustomComponents/Context/CustomerContext';

export default function PublicRoute({ children }) {
  const {cookies} = useContext(CustomerContext);
  const authed = (!(cookies.get('customer')==null));

  return authed === false ? children : <Navigate to="/Dashboard" replace />;
}